import { NavLink, Outlet, useLocation } from "react-router-dom";
import { ShieldCheck, Users, ClipboardList, UserCircle, Palette, Link2, Bell, ShieldAlert } from "lucide-react";
import BackButton from "../components/BackButton";
import { useApp } from "../lib/AppContext";

// NOTA (2026-09-05): le voci "Memoria IA" e "Cronologia IA" NON sono più
// nel menu (richiesta esplicita di Piera). Le route
// /settings/memoria-segretaria e /settings/cronologia-segretaria RESTANO
// attive e accessibili via URL diretto (bookmark), e i loro endpoint API
// continuano a funzionare per il chatbot (contesto LLM + rollback).
const TABS = [
  { to: "/settings/profile", label: "Profilo", icon: UserCircle, testid: "settings-tab-profile", owner: false },
  { to: "/settings/security", label: "Sicurezza", icon: ShieldCheck, testid: "settings-tab-security", owner: false },
  { to: "/settings/integrations/google", label: "Integrazioni", icon: Link2, testid: "settings-tab-integrations", owner: false },
  { to: "/settings/notifiche", label: "Notifiche", icon: Bell, testid: "settings-tab-notifiche", owner: false },
  { to: "/settings/privacy-e-dati", label: "Privacy e dati", icon: ShieldAlert, testid: "settings-tab-privacy", owner: false },
  { to: "/settings/collaborators", label: "Collaboratori", icon: Users, testid: "settings-tab-collaborators", owner: true },
  { to: "/settings/audit", label: "Audit", icon: ClipboardList, testid: "settings-tab-audit", owner: true },
  { to: "/settings/appearance", label: "Aspetto", icon: Palette, testid: "settings-tab-appearance", owner: false },
];

export default function SettingsHub() {
  const { user } = useApp();
  const loc = useLocation();
  const visible = TABS.filter((t) => !t.owner || user?.is_owner);

  return (
    <div className="space-y-6" data-testid="settings-hub">
      {/* Bug 21/50 · su /settings/<child> Shell mostra già il BackButton auto.
          Renderizziamo il back-button locale SOLO su /settings root, per evitare
          doppioni sulle sotto-pagine (es. /settings/appearance). */}
      {(loc.pathname === "/settings" || loc.pathname === "/settings/") && (
        <BackButton to="/" testid="settings-back-btn" />
      )}
      <div>
        <div className="text-xs font-mono uppercase tracking-widest opacity-70">Sistema</div>
        <h1 className="mt-1 font-display text-3xl sm:text-4xl font-semibold">Impostazioni</h1>
        <p className="mt-2 text-sm opacity-80 max-w-2xl">
          Gestisci il tuo profilo, la sicurezza dell'account, i collaboratori e l'aspetto dell'applicazione.
        </p>
      </div>

      <nav className="flex flex-wrap gap-2 border-b pb-3" style={{ borderColor: "var(--pxos-border)" }} data-testid="settings-tabs">
        {visible.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to} to={to} data-testid={testid}
            className={({ isActive }) =>
              [
                "inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition",
                isActive ? "bg-white shadow-sm border" : "hover:bg-white/70",
              ].join(" ")
            }
            style={{ color: "var(--pxos-text-dark)", borderColor: "var(--pxos-border)" }}
          >
            <Icon size={15} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="pt-2">
        {loc.pathname === "/settings" || loc.pathname === "/settings/" ? (
          <div className="pxos-card p-8 text-center opacity-70" data-testid="settings-empty-hint">
            Seleziona una sezione dalle schede in alto.
          </div>
        ) : <Outlet />}
      </div>
    </div>
  );
}
